export default __webpack_public_path__ + "static/Creative_Community-25d1861ffd04ffe6f720d264fb1f38bf.png";